import { Component, HostListener, ViewChild } from '@angular/core';
import { IonRouterOutlet, LoadingController, MenuController, ModalController, Platform, ToastController } from '@ionic/angular';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth'
import { TranslateService } from '@ngx-translate/core';
import { PageHelper } from './code/PageHelper';
import { App } from '@capacitor/app';
import { MyService } from './code/MyService';
import { NGXLogger } from 'ngx-logger';
import { SplashScreen } from '@capacitor/splash-screen'
import { PluginListenerHandle } from '@capacitor/core';
import { AuthService, UserProfile } from './code/auth-service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GlobalVarService } from './code/globalvar-service';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { LanguageService } from './code/language.service';
import { SignalRService } from './code/signalr.service';  // 引入 SignalR 服務

declare var window: any

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy{
  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;

  profile: UserProfile;
  backButtonPressedOnceToExit: boolean = false;
  private appMargin = 0;
  private readonly listenerHandlers: PluginListenerHandle[] = [];
  isAgreetSmarklook = false;
  currentLang: string = 'zh-TW';

  constructor(
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    private platform: Platform,
    private pageHelper: PageHelper,
    public menu: MenuController,
    public loadingController: LoadingController,
    public myService: MyService,
    public log: NGXLogger,
    public authService: AuthService,
    public router: Router,
    private globalVarService: GlobalVarService,
    private gtmService: GoogleTagManagerService,
    private translate: TranslateService,
    private storage: Storage,
    private languageService: LanguageService,
    private signalRService: SignalRService // 注入 SignalR 服務
  ) {
    window.addEventListener('keyboardDidShow', (e) => {
      const elementFocused: any = document.querySelector(':focus');
      if (elementFocused) {
        elementFocused.blur();
        elementFocused.focus();
      }
    });


    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'Router Page',
          pageName: this.getPageName(item.url),
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
    this.initializeApp();
  }
  getPageName(url: string) {
    if (url.includes("feedback")) {
      return "意見回饋";
    }
    if (url.includes("setting")) {
      return "設定";
    }
    if (url.includes("logout")) {
      return "功能選單";
    }
    return "找不到url : " + url;
  }

  async initializeApp() {
    // 初始化語言服務
    this.languageService.init();
    this.log.trace("AppComponent initializeApp start");
    this.platform.ready().then(() => {
      SplashScreen.show();
    })
  }
  ngOnInit() {
    // 啟動 SignalR 連接
    this.signalRService.startConnection();

    // 訂閱語言更新事件
    this.signalRService.onLanguageUpdated(() => {
      console.log('語言更新事件');
      console.log('重新載入語言' +this.languageService.getCurrentLanguage());
      this.loadLanguage(this.languageService.getCurrentLanguage());  // 語言更新時重新載入語言
    });
  }

  ngOnDestroy() {
    // 停止 SignalR 連接
    this.signalRService.stopConnection();
  }
  loadLanguage(lang: string) {
    // 載入最新的語系檔案
    this.translate.getTranslation(lang).subscribe(translations => {
      this.translate.setTranslation(lang, translations, true);  // 更新語系
      this.translate.use(lang);  // 切換語系
    });
  }
  async ngAfterViewInit() {

    //this.gtmService.addGtmToDom();
    // if (this.platform.is("capacitor")) {
    //   var profile = await this.authService.getUserProfile();
    //   this.gtmService.getDataLayer().push({ UserId: profile.userId });
    //   SplashScreen.hide();
    // } else {
    //   //為在本機用web除錯的環境，塞入測試id
    //   this.gtmService.getDataLayer().push({ UserId: 'inTestUser' });
    // }

  }

}
